module.exports = __webpack_public_path__ + "static/media/webroll02.bf711de8.mp4";